import { openDatabase, saveSnapshotDatabase } from "../Utils/db";

import { getPanelWidgetPresets } from "../data/panelWidgetsSeed";

import { WidgetsType } from "../interfaces/Widgets";

import CurrentWorkspace from "./Workspace";

/**
 * Siembra los paneles del Dashboard por defecto según el perfil (userType) en
 * el primer arranque. Espejo de SceneInitializer: si la tabla `widgets` ya
 * tiene algo (el usuario agregó paneles, o ya se sembró), no hace nada.
 */
class PanelWidgetInitializer {
  async initialize() {
    const db = await openDatabase();

    const widgets = await db?.widgets.toArray();

    // El panel del Bot se restaura solo en cuanto el bot está activo, y esa
    // restauración puede ganarle a la siembra. Si contara como "ya hay paneles"
    // dejaría el Dashboard con el Bot y nada más, así que no se cuenta.
    const sembrables = widgets?.filter(
      (widget) => widget.type !== WidgetsType.BOT,
    );

    // Ya hay paneles (sembrados o agregados por el usuario) → no re-sembrar.
    if (!db || !sembrables || sembrables.length > 0) return;

    const userType = await CurrentWorkspace.getType();

    const presets = getPanelWidgetPresets(userType);

    if (presets.length === 0) return;

    await db.widgets.bulkAdd(presets);

    await saveSnapshotDatabase();
  }
}

export default PanelWidgetInitializer;
